global.menu = [
  { name: "🟢หน้าขาย", link: "/sale/pos", show: false, menu: [] },
  {
    name: "🟢จัดการสั่งซื้อ/รับชำระ",
    link: "",
    show: false,
    menu: [
      { name: "🟢รายการขายสินค้า", link: "/payment/order-lists" },
      { name: "🟢ชำระเงิน", link: "/payment/payments" },
      { name: "🟢รายการชำระเงิน", link: "/payment/payments-lists" },
      { name: "🟢ประวัติชำระเงิน", link: "/payment/history-lists" },
    ],
  },
  {
    name: "🟢ค้างจ่าย(ลูกหนี้)",
    link: "",
    show: false,
    menu: [
      { name: "🟢ใบแจ้งหนี้", link: "/invoice/invoices" },
      { name: "🟢ใบวางบิล", link: "/invoice/billings" },
      { name: "🟢ใบลดหนี้", link: "/invoice/debt-reduces" },
    ],
  },
  {
    name: "🟢จัดการแจ้งซ่อม",
    link: "",
    show: false,
    menu: [
      { name: "🟢รายการใบแจ้งซ่อม", link: "/repair/repairs" },
      { name: "🟢อัพเดทต้นทุน", link: "/repair/update-cost" },
    ],
  },
  {
    name: "🟢จัดการสต็อก",
    link: "",
    show: false,
    menu: [
      { name: "🟢รับสินค้า", link: "/stock/receive-goods" },
      { name: "🟢คืนสินค้าให้ Sup", link: "/stock/return-goods" },
      { name: "🟢เบิกสินค้า", link: "/stock/withdrawal-goods" },
      { name: "🟢คืนสินค้าจากลูกค้า", link: "/stock/return-customer-goods" },
      { name: "🟢สต็อกสินค้า", link: "/stock/stock-lists" },
      { name: "🟢ประวัติสต็อก", link: "/stock/stock-histories" },
      { name: "🟢เช็คสต็อก", link: "/stock/stock-checks" },
    ],
  },
  {
    name: "🟢ตั้งค่าระบบเซียงกง",
    link: "",
    show: false,
    menu: [
      { name: "🟢พิมพ์บาร์โค้ด", link: "/setting/print-barcodes" },
      { name: "🟢ตั้งค่าบาร์โค้ด", link: "/setting/barcodes" },
      { name: "🟢หมวดหมู่", link: "/setting/categories" },
      { name: "🟢อะไหล่และการซ่อม", link: "/setting/spare-parts" },
      { name: "🟢ลูกค้า", link: "/setting/customers" },
      { name: "🟢ผู้ใช้งาน", link: "/setting/users" },
      { name: "🟢บทบาท", link: "/setting/roles" },
      { name: "🟢บัญชีธนาคาร", link: "/setting/banks" },
      { name: "🟢บริษัทที่จำหน่าย", link: "/setting/companies" },
      { name: "🟢คลังสินค้า", link: "/setting/warehouses" },
    ],
  },
  { name: "รายงาน", link: "", show: false, menu: [
      // { name: "รายการสั่งซื้อ", link: "/report/order-list-reports" },
      // { name: "รายการมัดจำ", link: "/report/deposit-list-reports" },
      { name: "รายการสถานะลูกหนี้", link: "/report/status-debtor-reports" },
      { name: "รายการต่อวันเฉพาะลูกหนี้", link: "/report/dialy-debtors-reports" },
      { name: "รายการชำระเงิน", link: "/report/payment-list-reports" },
      { name: "รายการใบแจ้งหนี้", link: "/report/invoice-reports" },
      { name: "รายการใบวางบิล", link: "/report/billing-reports" },
      { name: "รายการใบลดหนี้", link: "/report/debt-reduce-reports" },
      { name: "รายการแจ้งซ่อม", link: "/report/repair-reports" },
      { name: "รายการเบิกสินค้า", link: "/report/withdrawal-good-reports" },
      // { name: "รายงานต้นทุนซื้อ", link: "/report/update-cost-reports" },
      { name: "รายงานขาย", link: "/report/sale-reports" },
      { name: "รายงานรับสินค้า", link: "/report/receive-good-reports" },
      { name: "รายงานรับสินค้าแบบรวม", link: "/report/consolidated-good-reports" },
      { name: "รายงานคืนสินค้าให้ supplier", link: "/report/supplier-return-reports" },
      { name: "รายงานคืนสินค้าลูกค้า", link: "/report/customer-return-reports" },
      { name: "รายงานอัปเดทต้นทุน", link: "/report/cost-update-reports" },
  ] },
];

global.role = {
  "title1": "ตั้งค่า",
  "banks": "บัญชีธนาคาร",
  "barcodes": "บาร์โค้ด",
  "categories": "หมวดหมู่",
  "companies": "บริษัทที่จำหน่าย",
  "customers": "ลูกค้า",
  "print-barcodes": "พิมพ์บาร์โค้ด",
  "roles": "บทบาท",
  "spare-parts": "อะไหล่และการซ่อม",
  "users": "ผู้ใช้งาน",
  "warehouses": "คลังสินค้า",
  "title2": "สต็อก",
  "receive-goods": "รับสินค้า",
  "return-customer-goods": "คืนสินค้าจากลูกค้า",
  "return-goods": "คืนสินค้าให้",
  "stock-checks": "เช็คสต็อก",
  "stock-histories": "ประวัติสต็อก",
  "stock-lists": "สต็อกสินค้า",
  "withdrawal-goods": "เบิกสินค้า",
  "title3": "ขาย",
  "pos": "บันทึกรายการขาย",
  "title4": "รับชำระ",
  "order-lists": "รายการขายสินค้า",
  "payments": "ชำระเงิน",
  "payments-lists": "รายการชำระเงิน",
  "history-lists": "ประวัติชำระเงิน",
  "title5": "ค้างจ่ายลูกหนี้",
  "invoices": "รายการใบแจ้งหนี้",
  "billings": "ใบวางบิล",
  "debt-reduces": "ใบลดหนี้",
  "title6": "การซ่อม",
  "repairs": "รายการใบแจ้งซ่อม",
  "update-cost": "อัพเดทต้นทุน",
  "title7": "รายงาน",
  "report": "รายงาน",
"payment-list-reports": "รายการชำระเงิน",
"status-debtor-reports": "รายงานสถานะลูกหนี้",
"dialy-debtors-reports": "รายงานต่อวันเฉพาะลูกหนี้",
"invoice-reports": "รายการใบแจ้งหนี้",
"billing-reports": "รายการใบวางบิล",
"debt-reduce-reports": "รายการใบลดหนี้",
"repair-reports": "รายการแจ้งซ่อม",
"withdrawal-good-reports": "รายการเบิกสินค้า",
"sale-reports": "รายงานขาย",
"receive-good-reports": "รายงานรับสินค้า",
"consolidated-good-reports": "รายงานรับสินค้าแบบรวม",
"supplier-return-reports": "รายงานคืนสินค้าให้ supplier",
"customer-return-reports": "รายงานคืนสินค้าลูกค้า",
"cost-update-reports": "รายงานอัปเดทต้นทุน",
};

global.bank = [
  { front: <img alt="bank" src={require("../assets/images/bank/002.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "BBL", label: "ธนาคารกรุงเทพ" },
  { front: <img alt="bank" src={require("../assets/images/bank/004.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "KBANK", label: "ธนาคารกสิกรไทย" },
  { front: <img alt="bank" src={require("../assets/images/bank/006.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "KTB", label: "ธนาคารกรุงไทย" },
  { front: <img alt="bank" src={require("../assets/images/bank/011.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "TTB", label: "ธนาคารทหารไทยธนชาต" },
  { front: <img alt="bank" src={require("../assets/images/bank/014.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "SCB", label: "ธนาคารไทยพาณิชย์" },
  { front: <img alt="bank" src={require("../assets/images/bank/025.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "BAY", label: "ธนาคารกรุงศรีอยุธยา" },
  { front: <img alt="bank" src={require("../assets/images/bank/067.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "TISCO", label: "ธนาคารทิสโก้" },
  { front: <img alt="bank" src={require("../assets/images/bank/069.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "KKP", label: "ธนาคารเกียรตินาคินภัทร" },
  { front: <img alt="bank" src={require("../assets/images/bank/024.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "UOB", label: "ธนาคารยูโอบี" },
  { front: <img alt="bank" src={require("../assets/images/bank/022.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "CIMB", label: "ธนาคารซีไอเอ็มบีไทย" },
  { front: <img alt="bank" src={require("../assets/images/bank/073.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "LHBANK", label: "ธนาคารแลนด์ แอนด์ เฮ้าส์" },
  { front: <img alt="bank" src={require("../assets/images/bank/030.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "GSB", label: "ธนาคารออมสิน" },
  { front: <img alt="bank" src={require("../assets/images/bank/034.png")} width={18} height={18} style={{ marginRight: 6 }} />, value: "BAAC", label: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร" },
];

global.paper_size = [
  { value: "72x26 mm.", label: "72x26 mm.", width: 72, height: 26 },
  { value: "70x50 mm.", label: "70x50 mm.", width: 70, height: 50 },
]
// ตั้งค่า
// บัญชีธนาคาร        admin/setting/banks
// บาร์โค้ด           admin/setting/barcodes
// หมวดหมู่           admin/setting/categories
// บริษัทที่จำหน่าย      admin/setting/companies
// สร้าง ลูกค้า        admin/setting/create-customers
// แก้ไข ลูกค้า        admin/setting/update-customers
// ลูกค้า             admin/setting/customers
// พิมพ์บาร์โค้ด        admin/setting/print-barcodes
// บทบาท            admin/setting/roles
// อะไหล่และการซ่อม   admin/setting/spare-parts
// ผู้ใช้งาน           admin/setting/users
// คลังสินค้า          admin/setting/warehouses

// สต็อก
// รับสินค้า           admin/stock/receive-goods
// คืนสินค้าจากลูกค้า       admin/stock/return-customer-goods
// คืนสินค้าให้ Sup     admin/stock/return-goods
// เช็คสต็อก          admin/stock/stock-checks
// ประวัติสต็อก        admin/stock/stock-histories
// สต็อกสินค้า         admin/stock/stock-lists
// เบิกสินค้า          admin/stock/withdrawal-goods

// ขาย
// บันทึกรายการขาย    admin/sale/pos

// รับชำระ
// รายการสั่งซื้อ        admin/payment/order-lists
// รับชำระ            admin/payment/payments
// รายการชำระเงิน     admin/payment/payments-lists
// PDF บิลเบิกสินค้า
// PDF บิลเงินสด
// PDF บิลเงินยืมสินค้า
// PDF บิลมัดจำสินค้า
// PDF บิลแจ้งซ่อม

// ใบแล้วหนี้/ใบวางบิล
// ใบแจ้งหนี้/ใบส่งของ   admin/invoice/create-invoices
// รายการใบแจ้งหนี้     admin/invoice/invoices
// ใบวางบิล           admin/invoice/billings
// สร้างใบวางบิล       admin/invoice/create-billings
// ข้อมูลใบวางบิล       admin/invoice/detail-billings
// รับชำระใบวางบิล     admin/invoice/payment-billings

// การซ่อม
// สร้างใบแจ้งซ่อม      admin/repair/create-repairs
// ข้อมูลใบแจ้งซ่อม      admin/repair/detail-repairs
// รายการใบแจ้งซ่อม    admin/repair/repairs
// PDF บิลแจ้งซ่อม

// รายงาน
// รายงานรับสินค้าแบบละเอียด
// รายงานรับสินค้าแบบรวม
// รายงานคืนสินค้าให้ sup
// รายงานเบิกสินค้า
// รายงานคืนสินค้าจากลูกค้า
// รายงานขายสินค้า
// รายงานมัดจำ
// รายงานสต็อกคงเหลือ
// รายงานเช็คสต็อก
// รายงานใบแจ้งซ่อม
// รายงานใบแจ้งหนี้
// รายงานใบวางบิล
